import React, { useEffect, useState } from 'react';
import { withTranslation } from 'react-multi-lang';
import { Card, CardBody, CardHeader, Row, Col, Table, Input, Button,
        Modal, ModalHeader, ModalBody, ModalFooter, FormGroup, Label } from 'reactstrap';
import Select from 'react-select';
import VolumesService from '../Services/VolumesService';
import OffersService from '../Services/OffersService';
import makeAnimated from 'react-select/animated';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faSync } from '@fortawesome/free-solid-svg-icons';


const Offers = ({t}) => {
    const [offers, setOffers] = useState([]);
    const [volumes, setVolumes] = useState([]);
    const [offer, setOffer] = useState({});
    const [numOffers, setNumOffers] = useState(0);
    const [customers, setCustomers] = useState([]);
    const [newOfferCustomers, setNewOfferCustomers] = useState([]);
    const [newOffer, setNewOffer] = useState({});
    const [newOfferItems, setNewOfferItems] = useState([]);
    const [page, setPage] = useState(1);
    const [perPage, setPerPage] = useState(10);
    const [customerIdFilter, setCustomerIdFilter] = useState('');
    const [offerSearch, setOfferSearch] = useState('');
    const [customersSearch, setCustomersSearch] = useState('');
    const [currentOffer, setCurrentOffer] = useState(0);
    const [creatingOffer, setCreatingOffer] = useState(false);
    const [offerData, setOfferData] = useState({});
    const [prices, setPrices] = useState([]);
    const [terms, setTerms] = useState([]);
    const [termPrices, setTermPrices] = useState([]);
    const [offerPackages, setOfferPackages] = useState([]);
    const [offerPackage, setOfferPackage] = useState({});
    const [assessment1Volumes, setAssessment1Volumes] = useState([]);
    const [assessment2Volumes, setAssessment2Volumes] = useState([]);
    const [assessment3Volumes, setAssessment3Volumes] = useState([]);
    const [assessment4Volumes, setAssessment4Volumes] = useState([]);
    const [assessment5Volumes, setAssessment5Volumes] = useState([]);

    const toggleCreatingOffer = () => setCreatingOffer(!creatingOffer);
    
    const volumesService = new VolumesService();
    const offersService = new OffersService();

    const animatedComponents = makeAnimated();

    useEffect(() => {
        offersService.getOffers(offerSearch, customerIdFilter, 1, perPage).then(r => {
            setOffers(r[0]);
            setNumOffers(r[1] ? r[1] : 0);
        });
        setPage(1);
    }, [perPage, offerSearch, customerIdFilter]);
    useEffect(() => {
        offersService.getOffers(offerSearch, customerIdFilter, page, perPage).then(r => {
            setOffers(r[0]);
            setNumOffers(r[1] ? r[1] : 0);
        });
    }, [page]);

    useEffect(() => {
        offersService.getStock().then(r => {
            console.log(r);
            setVolumes(r.data)
        });

        offersService.getPrices().then(r => {
            setPrices(r);
        });
        offersService.getDeliveryTerms().then(r => {
            setTerms(r);
        });
        offersService.getTermPrices().then(r => {
            setTermPrices(r);
        });
        offersService.getPackages().then(r => {
            setOfferPackages(r);
        });
    }, []);

    useEffect(() => {
        offersService.getCustomers(customersSearch).then(r => setCustomers(r));
    }, []);

    const createOffer = () => {
        Promise.all(offersService.createOffers(newOfferCustomers, newOffer, !offerPackage?.id ? newOfferItems : 
            [...assessment1Volumes, ...assessment2Volumes, ...assessment3Volumes, ...assessment4Volumes, ...assessment5Volumes],
        )).then(r => {
            offersService.getOffers(offerSearch, customerIdFilter, 1, perPage).then(r => {
                setOffers(r[0]);
                setNumOffers(r[1] ? r[1].offersnum : 0);
            });
            setPage(1);
            toggleCreatingOffer();
            setNewOffer({});
            setNewOfferCustomers([]);
            setNewOfferItems([]);
            setAssessment1Volumes([]);
            setAssessment2Volumes([]);
            setAssessment3Volumes([]);
            setAssessment4Volumes([]);
            setAssessment5Volumes([]);
        })
    }

    const getOffer = (offerId) => {
        offersService.getOffer(offerId).then(r => setOfferData(r));
    }

    const syncToErp = (offer) => {
        offersService.syncToErp(offer.id).then(r => {
            offersService.getOffers(offerSearch, customerIdFilter, 1, perPage).then(r => {
                setOffers(r);
                setNumOffers(r[1] ? r[1] : 0);
            });
            setPage(1);
        })
    };

    const getPages = () => {
        let pages = [];
        for(let i = 1; i <= Math.ceil(numOffers / perPage); i++){
            pages.push(i);
        }
        return pages;
    };
    
    const getTermPrice = (term, qty) => {
        let termPrice = termPrices.filter(tp => tp.term === term)[0];
        return termPrice ? termPrice.cost * qty : 0;
    }
    
    const calculateMissingQty = (assessment) => {
        if(offerPackage?.id){
            let qty = newOfferItems.filter(oi => oi.assessment === assessment).reduce((a, b) => a + b.qty, 0);
            if(assessment === offerPackage.assessment1){
                return offerPackage.assessment1Qty - qty;
            }
            else if(assessment === offerPackage.assessment2){
                return offerPackage.assessment2Qty - qty;
            }
            else if(assessment === offerPackage.assessment3){
                return offerPackage.assessment3Qty - qty;
            }
            else if(assessment === offerPackage.assessment4){
                return offerPackage.assessment4Qty - qty;
            }
            else if(assessment === offerPackage.assessment5){
                return offerPackage.assessment5Qty - qty;
            }
        }
        else return 0;
    };
    
    const notInOfferPackage = (assessment) => {
        return offerPackage?.id && (offerPackage?.assessment1 !== assessment && offerPackage?.assessment2 !== assessment && offerPackage?.assessment3 !== assessment && offerPackage?.assessment4 !== assessment && offerPackage?.assessment5 !== assessment);
    }
    
    const getAssessmentVolumes = (i) => {
        let oitems = [];
        if(i === 1) oitems = assessment1Volumes;
        if(i === 2) oitems = assessment2Volumes;
        if(i === 3) oitems = assessment3Volumes;
        if(i === 4) oitems = assessment4Volumes;
        if(i === 5) oitems = assessment5Volumes;
        return oitems;
    }
    
    const setAssessmentVolumes = (i, volumes) => {
        if(i === 1) setAssessment1Volumes(volumes);
        if(i === 2) setAssessment2Volumes(volumes);
        if(i === 3) setAssessment3Volumes(volumes);
        if(i === 4) setAssessment4Volumes(volumes);
        if(i === 5) setAssessment5Volumes(volumes);
    }
    
    const checkOfferPackageQuantities = () => {
        for(let i = 1; i <= 5; i ++){
            let avs = getAssessmentVolumes(i);
            if(avs.reduce((qty, v) => qty + v.qty, 0) > offerPackage[`assessment${i}Qty`] * 1.05 
                || avs.reduce((qty, v) => qty + (v.qty ?? 0), 0) < offerPackage[`assessment${i}Qty`] * 0.95){
                return true;
            }
        }
        return false;
    }
    
    const validateVolumeAge = (v, minAge) => {
        let creationDate = new Date(v.date);
        let today = new Date();
        let diff = today.getTime() - creationDate.getTime();
        let diffDays = Math.ceil(diff / (1000 * 3600 * 24));
        let diffMonths = Math.ceil(diffDays / 30);
        return diffMonths >= minAge;
    }

    return <>
        <Card>
            <CardHeader className="bg-primary text-white">
                <h3>Προσφορές</h3>
            </CardHeader>
            <CardBody>
                <Row>
                    <Col md="1">
                        <Button color="primary" onClick={toggleCreatingOffer}><FontAwesomeIcon icon={faPlus} /> </Button>
                    </Col>
                    <Col md="5">
                        <Input type="search" placeholder={t('search')} onChange={(e) => setOfferSearch(e.target.value)} />
                    </Col>
                    <Col md="6">
                        <Select
                            closeMenuOnSelect={true}
                            components={animatedComponents}
                            defaultValue={[]}
                            options={[{value: '', label: ''}, ...customers.map(c => {
                                return {value: c.Code, label: c.TaxRegistrationNumber + ' - ' + c.Name}
                            })]}
                            onChange={(v) => setCustomerIdFilter(v.value)}
                        />
                    </Col>
                </Row>
                <hr />
                <Table responsive>
                    <thead>
                        <tr>
                            <th>Κωδικός Πελάτη</th>
                            <th colSpan={3}>Όνομα Πελάτη</th>
                            <th>Ημερομηνία</th>
                            <th>Τιμή προ έκπτωσης</th>
                            <th>Τελική Τιμή</th>
                            <th>Ενέργειες</th>
                        </tr>
                    </thead>
                    {
                        offers.length === 0 && <tr><td colSpan={3} className="text-center">Δεν υπάρχουν Εγγραφές</td></tr>
                    }
                    {
                        offers.map(o => {
                            return <tbody key={o.id}>
                                    <tr  onClick={() => {
                                        if(currentOffer === o.id){
                                            setCurrentOffer(0);
                                        }
                                        else{
                                            setCurrentOffer(o.id);
                                            getOffer(o.id);
                                        }
                                    }
                                    }>
                                        <td>{o.customerId}</td>
                                        <td colSpan={3}>{customers.filter(c => c.Code === o.customerId)[0] ? customers.filter(c => c.Code === o.customerId)[0].Name : ''}</td>
                                        <td>{o.dateTime.split('T')[0].split('-').reverse().join('-')} {o.dateTime.split('T')[1].substr(0, 5)}</td>
                                        <td>
                                            {
                                                o.total_price && parseFloat(o.total_price).toFixed(2)
                                            }
                                        </td>
                                        <td>
                                            {
                                                o.discounted_price && parseFloat(o.discounted_price).toFixed(2)
                                            }
                                        </td>
                                        <td>
                                            { !o.synced && <Button color="primary" size="sm" onClick={() => {
                                                    syncToErp(o);
                                                }}> <FontAwesomeIcon icon={faSync} /> </Button>
                                            }
                                            
                                        </td>
                                    </tr>
                                    {
                                        currentOffer === o.id && offerData.id === o.id && <tr>
                                            <th>Αριθμός Όγκου</th>
                                            <th>Αξιολόγηση</th>
                                            <th>Διαστάσεις</th>
                                            <th>Βάρος</th>
                                            <th>Τιμή</th>
                                            <th>Έκπτωση %</th>
                                            <th>Τελική Τιμή</th>
                                            <th colSpan={2}>Σχόλια</th>
                                        </tr>
                                    }
                                    {
                                        currentOffer === o.id && offerData.id === o.id && offerData.offerItems.map((oi, i) => {
                                            return <tr key={i}>
                                                <td>{oi.volume.erpNumber}</td>
                                                <td>{oi.volume.finalAssessment}</td>
                                                <td>{oi.volume.measurement.length}/{oi.volume.measurement.width}/{oi.volume.measurement.depth}</td>
                                                <td>{oi.volume.weight}</td>
                                                <td>{oi.price}</td>
                                                <td>{oi.discount}</td>
                                                <td>{(oi.price * (100-oi.discount) / 100).toFixed(2)}</td>
                                                <td>{oi.comment}</td>
                                            </tr>
                                        })
                                    }

                                </tbody>
                        })
                    }
                </Table>
                <Row>
                    <Col md="12">
                        {
                            page != 1 && <Button color="default" onClick={() => setPage(1)}>{t('first')}</Button>
                        }
                        {
                            page > 1 && <Button color="default" onClick={() => setPage(page-1)}>{t('previous')}</Button>
                        }
                        {
                            getPages().map(p => {
                                return <Button color={p === page ? 'primary' : 'default'} key={p} onClick={() => setPage(p)}>{p}</Button>
                            })
                        }
                        {
                            page < Math.ceil(numOffers / perPage) && <Button color="default" onClick={() => setPage(page+1)}>{t('next')}</Button>
                        }
                        {
                            page != Math.ceil(numOffers / perPage) && <Button color="default" onClick={() => setPage(Math.ceil(numOffers / perPage))}>{t('last')}</Button>
                        }
                    </Col>
                </Row>
            </CardBody>
        </Card>
        <Modal isOpen={creatingOffer} toggle={toggleCreatingOffer} size="xl" centered>
            <ModalBody>
                <Row>
                    <Col md="12">
                            <Button className="float-end" color="success"
                            onClick={() => {
                                setNewOfferCustomers([...newOfferCustomers, ''])
                            }}> <FontAwesomeIcon icon={faPlus} /> </Button>
                            <h3>Πελάτες</h3> 
                            
                            <hr />

                        <FormGroup>
                            { newOfferCustomers.map((cu, i) => {
                                return <div key={i}><Select
                                    closeMenuOnSelect={true}
                                    options={[{value: '', label: ''}, ...customers
                                    .filter(c => !newOfferCustomers.includes(c.Code))
                                    .map(c => {
                                        return {value: c.Code, label: c.TaxRegistrationNumber + ' - ' + c.Name}
                                    })]}
                                    onChange={(v) => {
                                        let noc = newOfferCustomers;
                                        noc[i] = v.value;
                                        setNewOfferCustomers(noc);
                                    }
                                }
                                /><br /></div>
                            }) }
                            
                        </FormGroup>
                        <FormGroup>
                            <Label>Παράδοση</Label>
                            <Input type="select" onChange={(e) => {
                                let no = {...newOffer};
                                no.term = e.target.value;
                                setNewOffer(no);
                            }}>
                                <option value="">Επιλέξτε Παράδοση</option>
                                {
                                    terms.map((t, i) => {
                                        return <option key={i} value={t.Code}>{t.Description}</option>
                                    })
                                }
                            </Input>
                        </FormGroup>
                        <hr />
                    </Col>
                    <Col md={12}>
                        <FormGroup>
                            <Label>Πακέτο προσφορών</Label>
                            <Input type={'select'} value={offerPackage?.id} onChange={(e) => {
                                setOfferPackage(offerPackages.filter(op => op.id === parseInt(e.target.value))[0] ?? {});
                            }}>
                                <option value=''>Χωρίς Πακέτο Προσφοράς</option>
                                {
                                    offerPackages.map((op, i) => <option key={i} value={op.id}>{op.name}</option>)
                                }
                            </Input>
                        </FormGroup>
                    </Col>
                    <Col md="12">
                        
                        
                        { !offerPackage?.id && <>
                            <Button className="float-end" color="primary" onClick={() => setNewOfferItems([...newOfferItems, {}])}><FontAwesomeIcon icon={faPlus} /></Button>

                            <h3>Όγκοι</h3>
                            <Table responsive>
                                <thead>
                                    <tr>
                                        <th>Όγκος</th>
                                        <th>Τιμή Μονάδας</th>
                                        <th>Προτεινόμενη Τιμή</th>
                                        {
                                            !offerPackage?.id &&
                                            <th>Έκπτωση</th>
                                        }
                                        <th>Έκπτωση (%)</th>
                                        <th>Μεταφορικά</th>
                                        <th>Τελική Τιμή</th>
                                        <th>Σχόλιο</th>
                                    </tr>
                                </thead>
                                <tbody>
                                {newOfferItems.map((oi, index) => {
                                    return <tr key={index}>
                                        <td width="30%">
                                            <Select
                                                closeMenuOnSelect={true}
                                                components={animatedComponents}
                                                defaultValue={[]}
                                                options={volumes
                                                    .filter(v => newOfferItems.filter(oo => oo.volumeId === v.volumeId).length === 0)
                                                    .map(v => {
                                                    return {value: v.volumeId, label: v.erpNumber + ' - ' + v.finalAssessment + ' - ' + v.weight + 'Kg'}
                                                })}
                                                onChange={(v) => {
                                                    let noi = [...newOfferItems];
                                                    noi[index].volumeId = v.value;
                                                    noi[index].price = 0;
                                                    noi[index].qty = volumes.filter(vo => vo.volumeId === v.value)[0].weight/1000;
                                                    noi[index].itemCode = volumes.filter(vo => vo.volumeId === v.value)[0].itemCode;
                                                    noi[index].assessment = volumes.filter(vo => vo.volumeId === v.value)[0].finalAssessment;
                                                    noi[index].discount_type = noi[index].discount_type ? noi[index].discount_type : "percent";
                                                    noi[index].discount_value = noi[index].discount_value ? noi[index].discount_value : 0;
                                                    noi[index].discount = noi[index].discount ? noi[index].discount : 0;
                                                    noi[index].unit_price = oi.itemCode && oi.assessment ? prices.filter(p => p.ItemCode === oi.itemCode && p.Quality === oi.assessment)[0].Price : 0;
                                                    noi[index].price = oi.itemCode && oi.assessment && (prices.filter(p => p.ItemCode === oi.itemCode && p.Quality === oi.assessment)[0].Price * oi.qty);
                                                    if(noi[index].discount_type === "percent"){
                                                        noi[index].discount = noi[index].discount_value;
                                                    }
                                                    else if(noi[index].discount_type === "value"){
                                                        let cost = oi.itemCode && oi.assessment && (prices.filter(p => p.ItemCode === oi.itemCode && p.Quality === oi.assessment)[0].Price * oi.qty);
                                                        let disc = noi[index].discount_value;
                                                        noi[index].discount = (disc / cost) * 100;
                                                    }
                                                    else if(noi[index].discount_type === "weight"){
                                                        //let cost = oi.itemCode && oi.assessment && (prices.filter(p => p.ItemCode === oi.itemCode && p.Quality === oi.assessment)[0].Price * oi.qty);
                                                        let disc = noi[index].discount_value;
                                                        let newWeight = oi.qty - disc;
                                                        let newPrice = oi.itemCode && oi.assessment && (prices.filter(p => p.ItemCode === oi.itemCode && p.Quality === oi.assessment)[0].Price * newWeight);
                                                        let discPrice = oi.price - newPrice;
                                                        noi[index].discount = (discPrice / oi.price) * 100;
                                                    }
                                                    console.log(noi[index].qty);
                                                    console.log(noi[index].itemCode);
                                                    console.log(noi[index].assessment);
                                                    setNewOfferItems(noi);
                                                }}
                                            />
                                        </td>
                                        <td>
                                            {
                                                oi.unit_price ? oi.unit_price.toFixed(2) : ''
                                            }
                                        </td>
                                        <td>
                                            {
                                                oi.price ? (oi.price).toFixed(2) : 0
                                            }
                                        </td>
                                        <td>
                                            <Input type="select" onChange={(e) => {
                                                let noi = [...newOfferItems];
                                                noi[index].discount_type = e.target.value;
                                                setNewOfferItems(noi);
                                            }}>
                                                <option value="percent">%</option>
                                                <option value="value">€</option>
                                                <option value="weight">Τόνοι</option>
                                            </Input>
                                            <Input type="number" min={0} step="any" onChange={(e) => {
                                                let noi = [...newOfferItems];
                                                noi[index].discount_value = e.target.valueAsNumber ? e.target.valueAsNumber : 0;
                                                if(noi[index].discount_type === "percent"){
                                                    noi[index].discount = noi[index].discount_value;
                                                }
                                                else if(noi[index].discount_type === "value"){
                                                    let cost = oi.itemCode && oi.assessment && (prices.filter(p => p.ItemCode === oi.itemCode && p.Quality === oi.assessment)[0].Price * oi.qty);
                                                    let disc = noi[index].discount_value;
                                                    noi[index].discount = (disc / cost) * 100;
                                                }
                                                else if(noi[index].discount_type === "weight"){
                                                    //let cost = oi.itemCode && oi.assessment && (prices.filter(p => p.ItemCode === oi.itemCode && p.Quality === oi.assessment)[0].Price * oi.qty);
                                                    let disc = noi[index].discount_value;
                                                    let newWeight = oi.qty - disc;
                                                    let newPrice = oi.itemCode && oi.assessment && (oi.unit_price * newWeight);
                                                    let discPrice = oi.price - newPrice;
                                                    noi[index].discount = (discPrice / oi.price) * 100;
                                                }
                                                if(!e.target.valueAsNumber) noi[index].discount = 0;
                                                setNewOfferItems(noi);
                                            }} />
                                        </td>
                                        <td>{!offerPackage?.id && oi.discount ? oi.discount.toFixed(2) : 0}
                                            {offerPackage?.id && offerPackage.discount.toFixed(2)}%</td>
                                        <td>
                                            {
                                                newOffer.term && getTermPrice(newOffer.term, oi.qty).toFixed(2)
                                            }
                                        </td>
                                        <td>
                                            {
                                                oi.itemCode && oi.assessment && ((oi.price * (100-oi.discount) / 100) + getTermPrice(newOffer.term, oi.qty)).toFixed(2)
                                            }
                                        </td>
                                        <td>
                                            <Input type="text"  onChange={(e) => {
                                                let noi = [...newOfferItems];
                                                noi[index].comment = e.target.value;
                                                setNewOfferItems(noi);
                                            }} />
                                        </td>
                                    </tr>
                                })
                                }
                                </tbody>
                            </Table>
                            </>
                        }

                        { offerPackage?.id && <>
                            <h2>Πακέτο: {offerPackage?.name}</h2>
                            {
                                [1, 2, 3, 4, 5].filter(i => offerPackage[`assessment${i}Qty`] ?? 0 > 0).map(i => <>
                                <h2>Αξιολόγηση: {offerPackage[`assessment${i}`]} - Ποσότητα: {offerPackage[`assessment${i}Qty`]} τόνοι
                                    - Επιλεγμένη Ποσότητα: {getAssessmentVolumes(i).reduce((qty, oi) => {
                                        return (oi.qty ?? 0) + qty;
                                    }, 0)} τόνοι</h2>
                                <Button disabled={offerPackage[`assessment${i}Qty`] < getAssessmentVolumes(i).reduce((qty, oi) => {
                                    return oi.qty + qty;
                                }, 0)} 
                                        className="float-end" color="primary" onClick={() => {
                                    let oitems = getAssessmentVolumes(i)
                                    
                                    setAssessmentVolumes(i, [...oitems, {}])
                                }}><FontAwesomeIcon icon={faPlus} /></Button>
    
                                <h3>Όγκοι</h3>
                                <Table responsive>
                                    <thead>
                                    <tr>
                                        <th>Όγκος</th>
                                        <th>Τιμή Μονάδας</th>
                                        <th>Προτεινόμενη Τιμή</th>
                                        {
                                            !offerPackage?.id &&
                                            <th>Έκπτωση</th>
                                        }
                                        <th>Έκπτωση (%)</th>
                                        <th>Μεταφορικά</th>
                                        <th>Τελική Τιμή</th>
                                        <th>Σχόλιο</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {getAssessmentVolumes(i).map((oi, index) => {
                                        return <tr key={index}>
                                            <td width="30%">
                                                <Select
                                                    closeMenuOnSelect={true}
                                                    components={animatedComponents}
                                                    defaultValue={[]}
                                                    options={volumes.filter(v => v.finalAssessment === offerPackage[`assessment${i}`])
                                                        .filter(v => !offerPackage[`assessment${i}minAge`] || validateVolumeAge(v, offerPackage[`assessment${i}minAge`]))
                                                        .filter(v => getAssessmentVolumes(i).filter(oo => oo.volumeId === v.volumeId).length === 0)
                                                        .map(v => {
                                                            return {value: v.volumeId, label: v.erpNumber + ' - ' + v.finalAssessment + ' - ' + v.weight + 'Kg'}
                                                        })}
                                                    onChange={(v) => {
                                                        let noi = [...getAssessmentVolumes(i)];
                                                        noi[index].volumeId = v.value;
                                                        noi[index].price = 0;
                                                        noi[index].qty = volumes.filter(vo => vo.volumeId === v.value)[0].weight/1000;
                                                        noi[index].itemCode = volumes.filter(vo => vo.volumeId === v.value)[0].itemCode;
                                                        noi[index].assessment = volumes.filter(vo => vo.volumeId === v.value)[0].finalAssessment;
                                                        noi[index].discount_type = "percent";
                                                        noi[index].discount_value = offerPackage.discount;
                                                        noi[index].discount = offerPackage.discount;
                                                        noi[index].unit_price = oi.itemCode && oi.assessment ? prices.filter(p => p.ItemCode === oi.itemCode && p.Quality === oi.assessment)[0].Price : 0;
                                                        noi[index].price = oi.itemCode && oi.assessment && (prices.filter(p => p.ItemCode === oi.itemCode && p.Quality === oi.assessment)[0].Price * oi.qty);
                                                        
                                                        console.log(noi[index].qty);
                                                        console.log(noi[index].itemCode);
                                                        console.log(noi[index].assessment);
                                                        setAssessmentVolumes(i, noi);
                                                    }}
                                                />
                                            </td>
                                            <td>
                                                {
                                                    oi.unit_price ? oi.unit_price.toFixed(2) : ''
                                                }
                                            </td>
                                            <td>
                                                {
                                                    oi.price ? (oi.price).toFixed(2) : 0
                                                }
                                            </td>
                                            <td>{!offerPackage?.id && oi.discount ? oi.discount.toFixed(2) : 0}
                                                {offerPackage?.id && offerPackage.discount.toFixed(2)}%</td>
                                            <td>
                                                {
                                                    newOffer.term && getTermPrice(newOffer.term, oi.qty).toFixed(2)
                                                }
                                            </td>
                                            <td>
                                                {
                                                    oi.itemCode && oi.assessment && ((oi.price * (100-oi.discount) / 100) + getTermPrice(newOffer.term, oi.qty)).toFixed(2)
                                                }
                                            </td>
                                            <td>
                                                <Input type="text"  onChange={(e) => {
                                                    let noi = [...getAssessmentVolumes(i)];
                                                    noi[index].comment = e.target.value;
                                                    setAssessmentVolumes(i, noi);
                                                }} />
                                            </td>
                                        </tr>
                                    })
                                    }
                                    </tbody>
                                </Table>
                                </>
                                )}
                        </>
                        }
                            
                        
                    </Col>
                </Row>
            </ModalBody>
            <ModalFooter>
                <Button disabled={offerPackage?.id && 
                    checkOfferPackageQuantities()
                } className="float-end" color="success" size="sm" onClick={createOffer}>{t('volumes.create')}</Button>
                <Button className="float-end" color="warning" size="sm" onClick={toggleCreatingOffer}>{t('volumes.close')}</Button>
            </ModalFooter>
        </Modal>
    </>
};

export default withTranslation(Offers);